import { plainToInstance } from 'class-transformer';
export function toTypedJSON(object) {
    return JSON.stringify(object);
}
export function fromTypedJSON(ctr, data) {
    const parsed = JSON.parse(data.toString());
    if ('type' in parsed && parsed.type !== ctr.type) {
        return undefined;
    }
    return plainToInstance(ctr, parsed);
}
//# sourceMappingURL=serialization.js.map